import { useEffect } from 'react';

import { useSidebarSummaryContext } from '../../../../SidebarSummary.context';
import {
  Background,
  StyledBasicTitle,
  StyledBiggerSubtitle,
  StyledImage,
  Wrapper,
} from './FinalAnimation.styled';

interface FinalAnimationProps {
  hideAnimation: boolean;
  onAnimationEnd?: () => void;
}

const AUDIO_URL =
  'https://audios.genially.com/5c9357997082c2326aa1498d/df7cd9e9-4c01-4204-9386-db65e53eb266.wav';

export const FinalAnimation = ({
  hideAnimation,
  onAnimationEnd,
}: FinalAnimationProps) => {
  const {
    state: { isOpen },
    config: { isAudioMuted, getTranslation },
  } = useSidebarSummaryContext();

  const handleAnimationEnd = () => {
    if (onAnimationEnd && hideAnimation) {
      onAnimationEnd();
    }
  };

  useEffect(() => {
    if (!isAudioMuted && isOpen) {
      const audio = new Audio(AUDIO_URL);
      audio.play();
    }
  }, [isAudioMuted, isOpen]);

  return (
    <Wrapper $activeHideAnimation={hideAnimation} onAnimationEnd={handleAnimationEnd}>
      <Background $activeAnimation={isOpen} />
      <StyledImage
        src="https://static.genially.com/genially/activities/flag"
        alt="Final animation"
        $activeAnimation={isOpen}
      />

      <StyledBasicTitle $activeAnimation={isOpen}>
        {getTranslation('__new.content.interactiveQuestion.sidebar.final.title')}
      </StyledBasicTitle>
      <StyledBiggerSubtitle $activeAnimation={isOpen}>
        {getTranslation('__new.content.interactiveQuestion.sidebar.final.description')}
      </StyledBiggerSubtitle>
    </Wrapper>
  );
};
